<template>
  <div class="fieldset">
    <h3 class="fieldset-heading">Custom Wishes</h3>

    <CustomWishesYN v-model="form.data.funeral.details.customWishesYN" />
    <CustomWishes
        v-if="details.customWishesYN"
        v-model="form.data.funeral.details.customWishesOption" />

  </div>
</template>

<script>
import { willPeopleHelpers} from "@/components/common/questionnaires/fieldsets/will/helpers/willPeopleHelpers";
import { fieldsetHelpers } from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import { willFuneralHelpers } from "@/components/common/questionnaires/fieldsets/will/helpers/willFuneralHelpers";
import {clone} from "@/mixins/clone";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";

import CustomWishesYN from "@/components/common/questionnaires/question/questions/will/funeral/CustomWishesYN";
import CustomWishes from "@/components/common/questionnaires/question/questions/will/funeral/CustomWishes";

export default {
  name: 'FuneralWishes',
  mixins: [
    fieldsetHelpers,
    willPeopleHelpers,
    clone,
    saveHelpers,
    willFuneralHelpers
  ],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    CustomWishesYN,
    CustomWishes
  },
  data() {
    return {
      label: 'Wishes', // used for steps progress
      primaryOptions: [],
      secondaryOptions: [],
      backupOptions: [],
      db: {
        saveLocation: 'product_will_data',
        saveField: 'details',
        formPath: 'data.funeral.details'
      }
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  }
};
</script>
